import * as yup from 'yup';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
export const useSignUpValidationSchema = () => {
    const { t } = useTranslation();
    return yup.object().shape({
        email: Yup.string().email('Enter a valid email').required('Email is required'),
        password: Yup.string()
            .required(t('common.form.validation.password.required'))
            .min(6, t('common.form.validation.password.short'))
            .max(256, t('common.form.validation.password.long'))
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@\\[-`{-~]).{6,64}$/, t('common.form.validation.password.letters')),
        passwordConfirmation: Yup.string()
            .label('Password Confirm')
            .required()
            .oneOf([Yup.ref('password')], 'Passwords do not match')
    });
};
